import React from "react";
import LegalPage from "@/components/legal/LegalPage";
import { usePrice } from "@/lib/price";

export default function Refund() {
  const { price } = usePrice();
  return (
    <LegalPage
      pageTitle="Refund Policy"
      slug="refund"
      seoDescription={`JobHacki refund policy: 7-day no-questions Whop refund window on the one-time ${price} All-Access membership, no countdown timers, no retention mazes.`}
      kicker="REFUND POLICY"
      title={<>7 days. <span className="bg-[#00FF66] px-2">No questions.</span></>}
      effectiveDate="June 11, 2026"
      accent="#00FF66"
      intro={<>JobHacki All-Access is a one-time {price} purchase processed by Whop. If it doesn&apos;t deliver, get your money back — through Whop, fast, no friction.</>}
      sections={[
        {
          title: "The 7-day window",
          body: (
            <p>Every paid JobHacki membership comes with a <b>7-day refund window</b> from the date of purchase. Inside that window you can request a full refund for any reason — no surveys, no &ldquo;why are you leaving&rdquo; calls, no retention mazes.</p>
          ),
        },
        {
          title: "How to request a refund",
          body: (
            <>
              <p>Refunds are processed through <b>Whop</b>, the same platform that took your payment. You have two options:</p>
              <ul className="space-y-2 list-disc pl-5">
                <li><b>From your Whop account.</b> Log in to <a className="font-bold border-b-2 border-current" href="https://whop.com" target="_blank" rel="noopener noreferrer">whop.com</a>, find your JobHacki purchase, and click <i>Request refund</i>. Whop typically processes them within a few business days back to the original payment method.</li>
                <li><b>Email us first.</b> Send a note to <a className="font-bold border-b-2 border-current" href="mailto:support@jobhacki.com">support@jobhacki.com</a> from the email you signed up with and we&apos;ll point you at the exact link. We do not process card refunds ourselves — Whop holds the card data, not us.</li>
              </ul>
            </>
          ),
        },
        {
          title: "What happens to your access",
          body: (
            <p>Once the refund is initiated, your All-Access membership is cancelled and you&apos;ll lose access to the gated tools (Resume Builder, Simulator, OmniCut, etc.). The free tier — Playbook Directory, Tool Directory, Job Directory — stays available with your account.</p>
          ),
        },
        {
          title: "After 7 days",
          body: (
            <p>Because All-Access is a one-time purchase (not a subscription), there&apos;s nothing to cancel after the refund window. You keep lifetime access to everything you&apos;ve unlocked, with no recurring charges.</p>
          ),
        },
        {
          title: "Chargebacks",
          body: (
            <p>If something feels off, please email us before opening a chargeback. Disputes with your bank cost both sides time and can affect your future ability to buy from Whop merchants. We&apos;d rather refund you in a click than fight a chargeback.</p>
          ),
        },
        {
          title: "Edge cases",
          body: (
            <p>Repeated buy-and-refund cycles or accounts found to be sharing or redistributing content (see <a className="font-bold border-b-2 border-current" href="/terms">Terms of Service</a>) may be ineligible for refunds at our discretion. For everyone else: the answer is yes, here&apos;s your money.</p>
          ),
        },
      ]}
    />
  );
}
